/**
 * The platform a listing is on, worked out from its URL (D-69): well-known marketplaces by name, any other
 * site by its own name ("marktplaats.nl" → "Marktplaats"). Used by the server when saving and by the form
 * to show what was detected.
 */
const KNOWN = [
    [/(^|\.)ebay\.[a-z.]+$/, "eBay"],
    [/(^|\.)finn\.no$/, "Finn"],
    [/(^|\.)blocket\.se$/, "Blocket"],
    [/(^|\.)tradera\.com$/, "Tradera"],
    [/(^|\.)cardmarket\.com$/, "Cardmarket"],
    [/(^|\.)tcgplayer\.com$/, "TCGplayer"],
    [/(^|\.)(facebook|fb)\.com$/, "Facebook"],
    [/(^|\.)vinted\.[a-z.]+$/, "Vinted"],
    [/(^|\.)amazon\.[a-z.]+$/, "Amazon"],
    [/(^|\.)mercari\.com$/, "Mercari"],
    [/(^|\.)etsy\.com$/, "Etsy"],
    [/(^|\.)dba\.dk$/, "DBA"],
    [/(^|\.)tori\.fi$/, "Tori"],
];
/** Second-level labels that are not the site's name, as in "shop.co.uk". */
const GENERIC = new Set(["co", "com", "org", "net", "ac", "gov", "edu"]);
export const PHYSICAL_STORE_PLATFORM = "Physical store";
export const UNKNOWN_PLATFORM = "Other";
/** "https://www.ebay.co.uk/itm/1" → "eBay"; null or an unreadable URL → "Other". */
export function platformOf(url) {
    const host = /^https?:\/\/([^/?#:]+)/i
        .exec((url ?? "").trim())?.[1]
        ?.toLowerCase()
        .replace(/^www\./, "");
    if (host?.includes(".") !== true)
        return UNKNOWN_PLATFORM;
    for (const [pattern, name] of KNOWN)
        if (pattern.test(host))
            return name;
    const labels = host.split(".");
    const second = labels.at(-2) ?? "";
    const name = labels.length >= 3 && GENERIC.has(second) ? (labels.at(-3) ?? second) : second;
    return name === "" ? UNKNOWN_PLATFORM : name.charAt(0).toUpperCase() + name.slice(1);
}
//# sourceMappingURL=platform.js.map